@if (bannerJson) {
  <div>
    <app-resource-banner [bannerJson]="bannerJson"></app-resource-banner>
  </div>
}
<div class="main-content-container">
  @if (!utilService.isMobile()) {
    <div class="page-title-container d-flex">
      <div class="page-title flex-grow-1 ng-star-inserted">
        <div class="mb-0 ng-star-inserted">
          <div class="d-flex align-items-center">
            <div class="pl-2 pr-2 ng-star-inserted"><a class="d-inline-flex" (click)="previous()"
              href="javascript:void(0)"><img src="assets/images/grid-back.png"></a></div>
              <div class="text-capitalize"> {{PageTitle || 'p.t.cs' |translate|async }} </div>
            </div>
          </div>
        </div>
      </div>
    }
    <div class="_wf-dts-bordershadowdetails">
      <!-- <div class="card"> -->
      @if (keys.length != 0 && patientData) {
        <div>
          @if (keys.length != 0) {
            <div [ngClass]="utilService.isMobile()?'mt-2 ml-2 _status-container':'dottab'">
              @if (!showobjarray) {
                @for (key of keys; track key) {
                  <div [ngClass]="utilService.isMobile()?'text-block-84 mb-1':'dottab2'"
                    [ngStyle]="utilService.isMobile()?{'width':'50%','text-align':'left'}:getStyle(keys.length)" align="center">
                    @if (patientData[key]!=undefined) {
                      <div class="dot" [ngClass]="patientData[key]!=undefined?patientData[key]:'NA'">
                      </div> {{key.display!=undefined?key.display:key}}
                    }
                  </div>
                }
              }
              @if (showobjarray) {
                @for (key of keys; track key) {
                  <div [ngClass]="utilService.isMobile()?'text-block-84 mb-1':'dottab2'"
                    [ngStyle]="utilService.isMobile()?{'width':'50%'}:getStyle(keys.length)" align="center">
                    <div class="dot" [ngClass]="patientData[key['key']]!=undefined?patientData[key['key']]:'NA'">
                    </div> {{key.display!=undefined?key.display:key}}
                  </div>
                }
              }
            <!-- </div> -->
            <!-- <div class="d-flex flex-row my-flex-container overflow-auto" *ngIf="keys.length == 0"> -->
            @if (keys.length == 0) {
              <div class="">
                <div class="text-block-cs">No Data Found</div>
              </div>
            }
          </div>
        }
        @if (table_heading && table_heading.length && data) {
          <div class="table-heading-container">
            @for (heading of table_heading; track heading.value) {
              @if (data[heading.value] != undefined) {
                <div class="column d-flex fa-lg table-heading-row">
                  <div class="service ml-4">{{heading.label | translate | async}}:</div>
                  <div class="service-item_heading ml-2"><strong>{{data[heading.value]}}</strong></div>
                </div>
              }
            }
          </div>
        }
      </div>
    }
    <div class="_wf-dts-mainshadowbox">
      @if (temp!=undefined && temp) {
        <div class="row mt-1">
          <div class="col-12 table-container">
            <div class="table-responsive">
              @if (temp!=undefined && temp.length != 0) {
                <table class="base-table table-hover">
                  <thead>
                    <!-- <tr> -->
                    <tr>
                      <ng-container>
                        <th>{{'f.l.s.no' | translate | async}}</th>
                        <th>{{'f.l.tat' |translate | async}}</th>
                        <th>{{'f.l.user_name' |translate |async}}</th>
                        <th>{{'f.l.clearence_type' | translate |async}}</th>
                        <th>{{'f.l.clearence_date_time' | translate |async}}</th>
                        <th>{{'f.l.remarks' |translate |async}}</th>
                        <th class="freeze">{{'f.l.action' | translate |async}}</th>
                      </ng-container>
                    </tr>
                  </thead>
                  <tbody>
                    @for (res of temp; track res; let i = $index) {
                      <tr>
                        <ng-container>
                          <td>{{i+1}}</td>
                          @if (res.critical_tat_expired) {
                            <td><span class="grid-high-icon p-0"></span>
                          </td>
                        }
                        @if (!res.critical_tat_expired && res.warning_tat_expired) {
                          <td><span
                          class="grid-medium-icon p-0"></span></td>
                        }
                        @if (!res.critical_tat_expired && !res.warning_tat_expired) {
                          <td>-</td>
                        }
                        @if (res.userName) {
                          <td>{{res.userName}}</td>
                        }
                        @if (!res.userName) {
                          <td>-</td>
                        }
                        <td>{{res.stage}}</td>
                        @if (!res.clearanceDateTime) {
                          <td>-</td>
                        }
                        @if (res.clearanceDateTime) {
                          <td>{{res.clearanceDateTime | dateTimeFormat}}
                          </td>
                        }
                        @if (res.remarks) {
                          <td>{{res.remarks}}</td>
                        }
                        @if (!res.remarks) {
                          <td>-</td>
                        }
                        <td class="freeze">
                          @if (roleService.checkAccessPermission(res.stage_id, 'encounter_dischargeClearance', 'adt') && res.status == 'NA' && res.valid) {
                            <button class="primary-btn clearance-grid-actions"
                              [disabled]="res.status == 'NA'"
                            (click)="redirectToLink(res)">{{res.status}}</button>
                          }
                          @if (roleService.checkAccessPermission(res.stage_id, 'encounter_dischargeClearance', 'adt')&& res.status != 'NA' && res.valid) {
                            <button class="primary-btn clearance-grid-actions"
                            (click)="redirectToLink(res)">{{res.status=='pending'?'Acknowledge':'Unacknowledge'}}</button>
                          }
                        </td>
                      </ng-container>
                    </tr>
                  }
                </tbody>
              </table>
            }
            @if (temp!=undefined && temp.length == 0) {
              <div class="card">
                <div class="card-body">
                  @if (keys.length == 0) {
                    <div class="d-flex flex-row my-flex-container overflow-auto">
                      <div class="text-center">No Data Found</div>
                    </div>
                  }
                </div>
              </div>
            }
          </div>
        </div>
      <!-- </span> -->
    </div>
  }
</div>
@if (!dataListForDhsGRid) {
  <div class="_wf-sdts-cleargreybg">
    @for (res of temp; track res; let i = $index) {
      <div class="_wf-sdts-clearcardlft">
        <div class="_wf-sdts-clearfirst-txt-clearbox">
          <div class="_wf-sdts-cleardocname">{{'f.l.s.no' | translate | async}}<br><span class="_wf-sdts-cleartimenum">{{i+1}}</span>
        </div>
        <div class="_wf-sdts-stagediv">
          <div>TAT</div>
          <div class="_wf-sdta-reportcompletediv">
            @if (res.critical_tat_expired) {
              <span class="text-span-19"><span
              class="grid-high-icon p-0"></span></span>
            }
            @if (!res.critical_tat_expired && res.warning_tat_expired) {
              <span
                class="text-span-19"><span class="grid-medium-icon p-0"></span></span>
              }
              @if (!res.critical_tat_expired && !res.warning_tat_expired) {
                <span
                class="text-span-19">-</span>
              }
            </div>
          </div>
        </div>
        <div class="_wf-sdts-clearfirst-txt-clearbox _wf-sdts-cleartxtbox">
          @if (res.userName) {
            <div class="_wf-sdts-cleardocname">{{'f.l.user_name' |translate |async}}<br><span
            class="_wf-sdts-cleartimenum">{{res.userName}}</span></div>
          }
          @if (!res.userName) {
            <div class="_wf-sdts-cleardocname">{{'f.l.user_name' |translate |async}}<br><span
            class="_wf-sdts-cleartimenum">-</span></div>
          }
          <div class="_wf-sdts-cleardocname">{{'f.l.clearence_type' | translate |async}}<br><span
          class="_wf-sdts-cleartimenum">{{res.stage}}</span></div>
          @if (res.clearanceDateTime) {
            <div class="_wf-sdts-cleardocname">{{'f.l.clearence_date_time' | translate |async}}<br><span
            class="_wf-sdts-cleartimenum">{{res.clearanceDateTime | dateTimeFormat}}</span></div>
          }
          @if (res.remarks) {
            <div class="_wf-sdts-cleartimeappoint">{{'f.l.remarks' |translate |async}}<br><span
            class="_wf-sdts-cleartimenum">{{res.remarks}}</span></div>
          }
          @if (!res.clearanceDateTime) {
            <div class="_wf-sdts-cleardocname">{{'f.l.clearence_date_time' | translate |async}}<br><span
            class="_wf-sdts-cleartimenum">-</span></div>
          }
          @if (!res.remarks) {
            <div class="_wf-sdts-cleartimeappoint">{{'f.l.remarks' |translate |async}}<br><span
            class="_wf-sdts-cleartimenum">-</span></div>
          }
        </div>
        <div class="_wf-sdts-clearfirst-txt-clearbox _wf-sdts-cleartxtbox">
          @if (res.valid) {
            <div class="_wf-sdts-cleardocname">{{'f.l.action' | translate |async}}<br>
              @if (roleService.checkAccessPermission(res.stage_id, 'encounter_dischargeClearance', 'adt') && res.status == 'NA' && res.valid) {
                <button class="primary-btn"
                [disabled]="res.status == 'NA'" (click)="redirectToLink(res)">{{res.status}}</button>
              }
              @if (roleService.checkAccessPermission(res.stage_id, 'encounter_dischargeClearance', 'adt')&& res.status != 'NA' && res.valid) {
                <button class="primary-btn"
                (click)="redirectToLink(res)">{{res.status=='pending'?'Acknowledge':'Unacknowledge'}}</button>
              }
            </div>
          }
        </div>
      </div>
    }
    @if (temp!=undefined && temp.length == 0) {
      <div class="card">
        <div class="card-body">
          @if (keys.length == 0) {
            <div class="d-flex flex-row my-flex-container overflow-auto">
              <div class="text-center">No Data Found</div>
            </div>
          }
        </div>
      </div>
    }
  </div>
}
@if (dataListForDhsGRid) {
  <div>
    @if (dataListForDhsGRid && fields) {
      <dhs-data-grid [fields]="fields" [config]="configList" [data]="dataListForDhsGRid">
      </dhs-data-grid>
    }
  </div>
}
</div>
</div>